export function dataURLtoFile(dataUrlImage, filename) {
    let arr = dataUrlImage.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bst = atob(arr[arr.length - 1]),
        n = bst.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bst.charCodeAt(n);
    }
    return new File([u8arr], filename, {type: mime});
}

